import Constants from '../Constants';
import HandleAsyncError from '../errors/ErrorHandlerDecorator';

import { HttpClient } from './HttpClient';
import type {SiteId} from "@zooplus/commons-lang";

export default class LocResourcesService extends HttpClient {
  public metricsService: any;

  constructor(metricsService: any) {
    super();
    this.metricsService = metricsService;
  }

  localeFormat = (lang: string): string => {
    const locale =
      lang.indexOf('-') !== -1
        ? lang.split('-')[0]
        : lang.indexOf('_') !== -1
          ? lang.split('_')[0]
          : lang;
    return locale === 'nb' ? 'no' : locale;
  };

  @HandleAsyncError()
  async onGetLocResources(siteId: SiteId, lang: string, keys: Array<string>) {
    const body = { keys: keys };
    const locale = this.localeFormat(lang);
    const response = await super.post(
      `${Constants.API.URI.LOC_RESOURCES}?siteId=${siteId}&lang=${locale}`,
      body,
    );
    return response.json();
  }
}
